<template>
  <div id="app">
    <!-- 顶部导航 -->
    <header_ style="display: none;" ref="exit_logins"/>
    <!-- 路由视图 -->
    <router-view></router-view>
  </div>
</template>

<script>
import header_ from './components/header_'
import contents from './components/contents'
import dingdanzl from './components/dingdanzl'
import login from './components/login'
export default {
  name: 'App',
  components: {
    header_,
    contents,
    dingdanzl,
    login,
  }
}
</script>

<style>
*{
  margin:0;
  padding: 0;
}
body{
  height: 100%;
  overflow:hidden;
}
@media screen and (max-width: 800px) {
  html {
    /*height: 100vh;*/
    background: #e6e6e6;
  }
  body{
    overflow:auto;
  }
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
a{
  text-decoration: none;
  color: #303133;
}
</style>



// WEBPACK FOOTER //
// src/App.vue